import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function MilestoneDateDialog({ open, onOpenChange, title, today, onSave }) {
  const [day, setDay] = useState("");
  const [note, setNote] = useState("");
  useEffect(() => {
    if (open) { setDay(""); setNote(""); }
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="milestone-date-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-[#0A1F44]">Set the actual date</DialogTitle>
          <DialogDescription>{title}. The date you recorded it and who recorded it are kept separately.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label htmlFor="ms-date">Actual achievement date (Melbourne)</Label>
            <Input id="ms-date" type="date" max={today} value={day} onChange={(e) => setDay(e.target.value)} data-testid="milestone-date-input" />
          </div>
          <div>
            <Label htmlFor="ms-note">Note (optional)</Label>
            <Input id="ms-note" value={note} onChange={(e) => setNote(e.target.value)} data-testid="milestone-date-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={!day} onClick={() => onSave(day, note)} data-testid="milestone-date-save"
                  className="bg-[#0A1F44] text-white hover:bg-[#0A1F44]/90">Save date</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
